import { useState } from 'react';
import { Eye, EyeSlash } from 'iconsax-reactjs';
import { TextInput, type TextInputProps } from './TextInput';
import styles from './Form.module.css';

export interface PasswordInputProps extends Omit<TextInputProps, 'type' | 'rightElement'> {
  /** Accessible name of the reveal toggle (state is conveyed with aria-pressed). */
  toggleLabel?: string;
}

export function PasswordInput({
  toggleLabel = 'Show password',
  autoComplete = 'current-password',
  disabled,
  ...rest
}: PasswordInputProps) {
  const [visible, setVisible] = useState(false);
  return (
    <TextInput
      {...rest}
      disabled={disabled}
      type={visible ? 'text' : 'password'}
      autoComplete={autoComplete}
      spellCheck={false}
      autoCapitalize="off"
      rightElement={
        <button
          type="button"
          className={styles.inlineButton}
          aria-label={toggleLabel}
          aria-pressed={visible}
          disabled={disabled}
          onClick={() => setVisible((v) => !v)}
        >
          {visible ? (
            <EyeSlash size={18} color="currentColor" aria-hidden="true" />
          ) : (
            <Eye size={18} color="currentColor" aria-hidden="true" />
          )}
        </button>
      }
    />
  );
}
